import { Switch } from '@mui/material'
import { FieldError, Label } from 'components/core-v2/atoms'
import { ReactNode } from 'react'
import { RegisterOptions, useFormContext } from 'react-hook-form'
import { ClassName } from 'types/props'

import { getFieldIds } from './__utils__/getFieldIds'
import classes from './toggle-field.module.scss'

export interface ToggleProps extends ClassName {
  id: string
  isDisabled?: boolean
  label: ReactNode
  validators?: RegisterOptions
}

export const ToggleField = ({
  className,
  id,
  isDisabled = false,
  label,
  validators
}: ToggleProps) => {
  const {
    formState: { defaultValues, errors },
    register
  } = useFormContext()

  const error = errors[id]?.message
  const { describedBy, errorId, inputId } = getFieldIds(id)

  return (
    <div className={className}>
      <Label className={classes.label} htmlFor={id}>
        <span className="mr-1">{label}</span>
        <Switch
          aria-describedby={describedBy}
          defaultChecked={defaultValues[id]}
          disabled={isDisabled}
          id={inputId}
          type="checkbox"
          {...register(id, validators)}
        />
      </Label>
      {error && (
        <FieldError id={errorId} shouldHaveMarginTop={false}>
          {error.toString()}
        </FieldError>
      )}
    </div>
  )
}
